export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderConversations@2x.png";